import { ApiService } from 'src/services/core';
import VwOrgYetkiKullanici from 'src/models/Base/Yetki/VwOrgYetkiKullaniciDTO';

class OrgKullaniciService extends ApiService<VwOrgYetkiKullanici>{
    constructor() {
        super('VwOrgYetkiKullaniciDTO');
    }

    getKullaniciByOrganizasyon = (organizasyonId: number) => {
        return this.find({
            filters: {
                groupOperator: "and",
                predicates: [
                    { fieldName: "fkOrganizasyon", operator: "=", value1: organizasyonId }
                ]
            },
            sorts: [
                { fieldName: "kullaniciAdsoyad" }
            ]
        })
    }
}
export default new OrgKullaniciService();